import { browserHistory } from 'react-router';
import React from 'react';
import { Provider } from 'react-redux';
import { Router } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import { isFunction, flow, get } from 'lodash';
import { util } from 'veritone-redux-common';

const Sagas = util.reactReduxSaga.Sagas;

import configureStore from './store/reduxConfig/store/configureStore';
import {
  EnsureUserIsAuthenticated,
  // EnsureUserCompletedDevSignup
} from 'helpers/auth';

import App from 'plugins/app/App';
import noAccessRoute from 'plugins/noAccess';
import notFoundRoute from 'plugins/notFound';
import onboardingRoute from 'plugins/onboarding';
import enginesRoute from 'plugins/engines';
import enginesRoute2 from 'plugins/engines-old';
import automateStudioRoute from 'plugins/automate-studio';
import applicationsRoute from 'plugins/applications';
import documentationRoute from 'plugins/documentation';
import overviewRoute from 'plugins/overview';
import dataSchemaRoute from 'plugins/structured-data';
import machineBoxRoute from 'plugins/machine-box';
import aiwareRoute from 'plugins/aiware';

const PassThrough = (props) => props.children;

// TODO: this is commented for temporary solution in CXDX-249
// and need to be removed comment after CXDX-143 is deployed
const AuthChecks = flow([
  // EnsureUserCompletedDevSignup,
  EnsureUserIsAuthenticated,
])(PassThrough);

export function runConfig() {
  const store = configureStore();
  const history = syncHistoryWithStore(browserHistory, store);
  const isAnywhere = get(window, 'config.isAnywhere', false);

  const rootRoute = {
    path: '/',
    component: App,
    indexRoute: {
      onEnter: (nextState, replace) => replace('/overview'),
    },
    childRoutes: [
      {
        component: EnsureUserIsAuthenticated(PassThrough),
        childRoutes: [onboardingRoute],
      },
      {
        component: AuthChecks,
        childRoutes: [
          // auth-protected top-level routes
          overviewRoute,
          enginesRoute,
          enginesRoute2,
          automateStudioRoute,
          applicationsRoute,
          documentationRoute,
          dataSchemaRoute,
          aiwareRoute,
          isAnywhere ? null : machineBoxRoute,
          noAccessRoute,
          notFoundRoute,
        ]
          .filter(Boolean)
          .map((r) => (isFunction(r) ? r(store) : r)),
      },
    ],
  };

  return {
    store,
    history,
    rootRoute,
  };
}

export const RootComponent = (
  { store, history, rootRoute } // eslint-disable-line
) => (
  <Provider store={store}>
    <Sagas middleware={store.sagaMiddleware}>
      <Router history={history} routes={rootRoute} />
    </Sagas>
  </Provider>
);



// WEBPACK FOOTER //
// ./src/client/configure.js